import React, { useEffect } from 'react';
import { isEmpty } from 'ramda';
import { useParams } from 'react-router-dom';

// store
import { storeSet, useStoreValue } from '../../../../store';

// components
import NavigationButtons from './components/NavigationButtons';
import StudioLogo from './components/StudioLogo';
import SubPageTitle from './components/SubPageTitle';
import VideoList from './components/VideoList';
import MusicList from './components/MusicList';
import AudioList from './components/AudioList';
import RecList from './components/RecList';
import SlidingDeck from './components/SlidingDeck';

const MyStudioLeftPanel = () => {
    const { projectId } = useParams();
    const myStudioLeftPanel = useStoreValue('myStudioLeftPanel');

    useEffect(() => {
        if (myStudioLeftPanel === 'rec') {
            storeSet('fetchRecSessions', projectId);
        }
    }, [myStudioLeftPanel, projectId]);

    const handleChangePanelState = (value) => {
        storeSet('myStudioLeftPanel', value);
    }

    return (
        <div className="MyStudioLeftPanel">
            <NavigationButtons
                myStudioLeftPanel={myStudioLeftPanel}
                handleChangePanelState={handleChangePanelState}
            />
            <StudioLogo />
            {!isEmpty(myStudioLeftPanel)
                ? <div className="timelineEditorAuxControls__subPage">
                    <SubPageTitle/>
                    <div className="timelineEditorAuxControls__subPageBody">
                        <VideoList />
                        <MusicList />
                        <AudioList />
                        <RecList />
                    </div>
                </div>
                : null}
            <SlidingDeck/>
        </div>
    )
}

export default MyStudioLeftPanel;